<div class="d-flex align-items-center justify-content-center h-100">
  <img src="./assets/img/decoration/no-result.svg" alt="No result image" width="800" height="800" class="img-fluid" />
</div>
